import { Component, EventEmitter, Input, Output, HostBinding, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { IconSizeEnum } from '../../../_enums/icon.enum';
import { ITag } from '../../../_interfaces/tag.interface';
import { PositionEnum } from '../../../_enums/position.enum';
import { SdBannerComponent } from '../../medias/banner/banner.component';
import { SdCopyToClipboardDirective } from '../../../_directives/copyToClipBoard.directive';
import { SdIconComponent } from '../../icons/icon/icon.component';
import { SdThemeComponent } from '../../abstract/theme/theme.component';
import { ThemesEnum } from '../../../_enums/themes.enum';

@Component({
  selector: 'sd-tag',
  templateUrl: './tag.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SdCopyToClipboardDirective,
    SdIconComponent,
    SdBannerComponent,
    TranslateModule
  ]
})
export class SdTagComponent extends SdThemeComponent {
  @Input()
  tagData: ITag;

  @Input()
  isButton = false;

  @Input()
  isCopyTag = false;

  @Output()
  tagClicked = new EventEmitter<boolean>();

  @Output()
  copied: EventEmitter<string> = new EventEmitter<string>();

  @Input()
  class = ''; // override the standard class attr with a new one.
  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.isCopyTag ? 'is-copy-tag' : '',
      this.tagData?.isDark ? 'is-text-dark' : ''
    ].filter(Boolean).join(' ');
  }

  iconSize = IconSizeEnum;
  themesEnum = ThemesEnum;
  positionEnum = PositionEnum;
  isCopied = false;

  constructor(private readonly cdRef: ChangeDetectorRef) {
    super();
  }

  onTagClick() {
    this.tagClicked.emit(true);
  }

  tagIsCopied(event: string) {
    if (event?.length > 0) {
      this.isCopied = true;
      this.copied.emit(event);

      setTimeout(() => {
        this.isCopied = false;
        this.cdRef.markForCheck();
      }, 4000);
    }
  }
}
